__turbopack_context__.v({
  "textButton": "OyEcVa_textButton",
  "tone-weak": "OyEcVa_tone-weak",
});
